import { recentProjects } from "../mock/RecentProjects";

const RecentProjectModel = () => {
  const itemClass = `carousel-item ${recentProjects.isActive ? "active" : ""}`;

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ background: "#000" }}
    >
      <div className="modal-dialog" style={{ maxWidth: "1100px !important" }}>
        <div
          className="modal-content"
          style={{ background: "none", border: "none" }}
        >
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <button
              type="button"
              className="btn-close text-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{ fontSize: "24px", background: "#ccc !important" }}
            ></button>
          </div>
          <div className="modal-body">
            <div
              id="carouselExampleControls"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div
                className="carousel-inner mx-5"
                style={{
                  width: "900px !important",
                  height: "700px !important",
                }}
              >
                {recentProjects.map((item) => (
                  <div className={itemClass} key={item.id}>
                    <img
                      src={item.imgSrc}
                      className="d-block w-100"
                      alt="projectAlt"
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                  style={{ marginRight: "130px" }}
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentProjectModel;
